import type { Meta, StoryObj } from "@storybook/react";

import { Button, Text } from "@/ui/core";
import type { BaseCardProps } from "@/ui/layout";
import { BaseCard, VStack } from "@/ui/layout";
import { baseCardStyles } from "@/ui/layout/BaseCard";

const StoryMeta: Meta<BaseCardProps> = {
  title: "Layout/Base Card",
  component: BaseCard,
  argTypes: {
    accessibilityLabel: { control: "text" },
    isBorderDashed: { control: "boolean" },
    isSelected: { control: "boolean" },
    onPress: { action: "pressed" },
    testID: { control: "text" },
    variant: {
      control: "select",
      options: Object.keys(baseCardStyles),
    },
  },
  args: {
    accessibilityLabel: "Base Card",
    isBorderDashed: false,
    isSelected: false,
    testID: "storybook",
    variant: "primary",
  },
};

type Story = StoryObj<BaseCardProps>;

const Primary: Story = {
  render: (args) => {
    return (
      <BaseCard {...args}>
        <VStack gap={10}>
          <Text testID="Storybook">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            various enim in eros elementum tristique
          </Text>

          <Button
            onPress={() => console.log("Button pressed")}
            size="small"
            testID="Storybook"
            title="Lorem ipsum"
          />
        </VStack>
      </BaseCard>
    );
  },
};

const Selected: Story = {
  ...Primary,
  args: { ...Primary.args, isSelected: true },
};

const WithBorderDashed: Story = {
  ...Primary,
  args: { ...Primary.args, isBorderDashed: true },
};

const Secondary: Story = {
  ...Primary,
  args: { ...Primary.args, variant: "secondary" },
};

export { Primary, Secondary, Selected, WithBorderDashed };
export default StoryMeta;
